<template>
  <div class="milestone-task-table">
    <div class="table-top">
      <div class="table-title">里程碑任务({{ this.pageInfo.total }})</div>
      <base-button v-if="from !== 'version' && hasCreateTask" @click="openCreateMilestone">
        +里程碑
      </base-button>
    </div>
    <div class="milestone-table">
      <base-table
        ref="baseTable"
        style="height: 100%;width: 100%;"
        default-expand-all
        :data="milestoneList"
        :show-pagination="showPagination"
        frontendPagination
        :page-info="pageInfo"
        @row-click="openDetails"
      >
        <el-table-column width="50px" align="center">
          <template slot-scope="scope">
            {{ (pageInfo.currentPage - 1) * 10 + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column
          v-for="column in milestoneTableColumns"
          :key="column.value"
          headerAlign="center"
          :align="column.contentAlign"
          :label="column.label"
          :prop="column.value"
          :min-width="column.width"
          contentAlign
          :column-key="column.value"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <template v-if="column.prop === 'name'">
              <svg-icon icon-class="milestone" style="color: #FF7373; margin-right: 3px"></svg-icon>
              {{ scope.row[column.prop] }}
            </template>
            <template v-else-if="column.prop === 'status'">
              <div class="status">
                <span v-show="scope.row.status === '已完成'" class="status-icon">
                  <svg-icon icon-class="success" class="icon-finish"></svg-icon>
                </span>
                <span v-show="scope.row.status === '待审核'" class="status-icon">
                  <svg-icon icon-class="need-verify" class="icon-need-verify"></svg-icon>
                </span>
                <span v-show="scope.row.status === '待处理'" class="status-icon">
                  <span class="icon-round"></span>
                </span>
                {{ scope.row.status }}
              </div>
            </template>
            <template v-else-if="column.prop === 'dueDate' || column.prop === 'completeAt'">
              {{
                [undefined, null, ""].includes(scope.row[column.prop])
                  ? ""
                  : scope.row[column.prop].substring(0, 10)
              }}
            </template>
            <template v-else>
              {{ _.get(scope.row, column.prop) || "" }}
            </template>
          </template>
        </el-table-column>
      </base-table>
    </div>
    <edit-dialog
      from="milestone"
      ref="editDialog"
      isMilestone
      :task-group="taskGroup"
      :project-id="projectId"
      :visible.sync="editDialogVisible"
      @after-submit="refreshTable"
    ></edit-dialog>
    <detail-dialog
      isMilestone
      ref="detailDialog"
      :task-id="taskId"
      :visible.sync="detailDialogVisible"
      @data-changed="refreshTable"
    ></detail-dialog>
  </div>
</template>

<script>
import BaseButton from "@/components/UIComponents/Button.vue"
import BaseTable from "@/components/UIComponents/BaseTable.vue"
import { milestoneTableColumns } from "@/views/Front/Project/Milestone/static"
import { getTaskGroupList } from "@/api/project/task"
import EditDialog from "@/components/Task/EditDialog/index.vue"
import DetailDialog from "@/components/Task/DetailDialog/index.vue"
import { getProject, getProjectMembers } from "@/api/project/project"
export default {
  name: "milestone-task-table",
  components: { DetailDialog, EditDialog, BaseTable, BaseButton },
  props: {
    projectId: String,
    milestoneList: Array,
    from: String
  },
  data() {
    return {
      pageInfo: {
        total: 0,
        currentPage: 1,
        pageSize: 10
      },
      detailDialogVisible: false,
      editDialogVisible: false,
      showPagination: true,
      taskGroup: {},
      taskId: "",
      milestoneTableColumns,
      hasCreateTask: false
    }
  },
  watch: {
    "milestoneList.length": function() {
      this.pageInfo.total = this.milestoneList?.length || 0
    }
  },
  computed: {
    curUser() {
      return this.$store.getters.userInfo
    }
  },
  beforeCreate() {
    this.$options.components.DetailDialog = require("@/components/Task/DetailDialog").default
    this.$options.components.EditDialog = require("@/components/Task/EditDialog").default
  },
  updated() {
    if (this.from !== "version") this.isHasCreateTask()
  },
  methods: {
    openDetails(row) {
      if (this.from === "version") return
      this.taskId = row.id
      this.detailDialogVisible = true
    },
    async openCreateMilestone() {
      let taskGroups = await getTaskGroupList(this.projectId)
      this.taskGroup = taskGroups[0]
      this.editDialogVisible = true
    },
    async isHasCreateTask() {
      // 获取新建权限
      let createRoleList = await getProject(this.projectId).then(res => res?.privilege?.roleList)
      if (createRoleList === null || createRoleList === undefined || createRoleList.length === 0) {
        this.hasCreateTask = true
        return
      }
      // 获取用户权限
      let userRoleList = await getProjectMembers(this.projectId).then(members => {
        return members.find(member => member.userId === this.curUser.userId).roles
      })
      if (this._.intersection(createRoleList, userRoleList).length > 0) this.hasCreateTask = true
      else this.hasCreateTask = false
    },
    refreshTable() {
      this.$emit("data-changed")
    }
  }
}
</script>

<style scoped lang="scss">
.milestone-task-table {
  width: calc(100% - 64px);
  background: #ffffff;
  border-radius: 6px;
  padding: 14px 16px 0 16px;
  margin-top: 16px;
  .table-top {
    margin-bottom: 12px;
    display: flex;
    justify-content: space-between;
    .table-title {
      font-size: 16px;
      font-weight: 500;
      color: #313132;
      line-height: 22px;
    }
  }
  .milestone-table {
    height: calc(100% - 44px);
    .status {
      @include flex-center;

      .status-icon {
        font-size: 16px;
        margin-right: 8px;
      }

      .icon-need-verify {
        color: #ffa150;
      }

      .icon-finish {
        color: #69e0af;
      }

      .icon-round {
        display: block;
        width: 16px;
        height: 16px;
        border-radius: 50%;
        box-sizing: border-box;
        border: 1px solid #dcdfe6;
      }
    }
  }
}
</style>
